module.exports = __webpack_public_path__ + "static/media/npm.494fd495.svg";